
import React from "react";
import { format } from "d3-format";
import { timeFormat } from "d3-time-format";

// Pond
import { TimeRange, TimeSeries } from "pondjs";

// Imports from the charts library
import {
    Charts,
    ChartContainer,
    ChartRow,
    YAxis,
    LineChart,
		Legend,
		Resizable,
		styler
} from "react-timeseries-charts";

const style = styler([
    { key: "portfolio", color: "steelblue", width: 1, dashed: true },
    { key: "benchmark", color: "#F68B24", width: 2 }
]);

class Chart extends React.Component {
		state = {
				tracker: null,
				range: new TimeRange(this.props.data[0][0], this.props.data[this.props.data.length - 1][0]),
				effectiveRange: new TimeRange(this.props.data[0][0], this.props.data[this.props.data.length - 1][0]),
				points: this.props.data
		};

		handleTrackerChanged = tracker => {
				this.setState({ tracker });
		};

    handleTimeRangeChange = timerange => {
				var desiredStartDate = timerange.begin();
				if (desiredStartDate !== this.state.range.begin()) {
						this.setState({points : this.unifyStartPoint(desiredStartDate, this.props.data)});
				}
        this.setState({effectiveRange: timerange});
    };

		unifyStartPoint = (desiredStartDate, allPoints) => {
				var desiredStartMillis = desiredStartDate.getTime();
				var points = [];
				var found = false;
				var factor1 = null;
				var factor2 = null;
				for (var i = 0; i < allPoints.length; i++) {
						if (!found && allPoints[i][0] >= desiredStartMillis) {
								found = true;
								factor1 = 1 / (1 + allPoints[i][1]);
								factor2 = 1 / (1 + allPoints[i][2]);
						}
						if (found) {
								points.push([allPoints[i][0], (1 + allPoints[i][1]) * factor1 - 1, (1 + allPoints[i][2]) * factor2 - 1]);
						}
				}
				if (!found) {
						throw new Error("desiredStartDate not found:" + desiredStartDate + "|" + desiredStartMillis);
				}
				return points;
		}

    render() {
				const points = this.state.points;
				const returnSeries = new TimeSeries({
				    name: "Returns %",
				    columns: ["time", "portfolio", "benchmark"],
				    points: points
				});
        const f = format(".2%");
        const df = timeFormat("%b %d %Y %X");
				const maxReturn = Math.max(returnSeries.max("portfolio"), returnSeries.max("benchmark"));
				const minReturn = Math.min(returnSeries.min("portfolio"), returnSeries.min("benchmark"));

        const timeStyle = {
            fontSize: "1rem",
            color: "#999"
        };

        let portfolioPerformance, benchmarkPerformance;
        if (this.state.tracker) {
            const index = returnSeries.bisect(this.state.tracker);
            const trackerEvent = returnSeries.at(index);
            portfolioPerformance = `${f(trackerEvent.get("portfolio"))}`;
            benchmarkPerformance = `${f(trackerEvent.get("benchmark"))}`;
        }

        return (
            <div>
                <div className="row" style={{ height: 28, display: 'flex', justifyContent: 'space-between' }}>
                    <div className="col-md-6" style={timeStyle}>
                        {this.state.tracker ? `${df(this.state.tracker)}` : ""}
                    </div>
                    <div className="col-md-6">
                        <Legend
                            type="line"
                            align="right"
                            style={style}
                            highlight={this.state.highlight}
                            onHighlightChange={highlight => this.setState({ highlight })}
                            selection={this.state.selection}
                            onSelectionChange={selection => this.setState({ selection })}
                            categories={[
                                { key: "portfolio", label: "portfolio", value: portfolioPerformance },
                                { key: "benchmark", label: "SP500", value: benchmarkPerformance }
                            ]}
                        />
                    </div>
                </div>
                <hr />
                <div className="row">
                    <div className="col-md-12">
                        <Resizable>
                            <ChartContainer
                                timeRange={this.state.effectiveRange}
                                maxTime={this.state.range.end()}
                                minTime={this.state.range.begin()}
                                trackerPosition={this.state.tracker}
                                onTrackerChanged={this.handleTrackerChanged}
                                onBackgroundClick={() => this.setState({ selection: null })}
                                enablePanZoom={true}
                                onTimeRangeChanged={this.handleTimeRangeChange}
                                minDuration={1000 * 60 * 60 * 24 * 30}
                            >
                                <ChartRow height="400">
                                    <YAxis
                                        id="y"
                                        min={minReturn}
                                        max={maxReturn}
                                        width="60"
                                        type="linear"
                                        format=".2%"
                                    />
                                    <Charts>
                                        <LineChart
                                            axis="y"
                                            breakLine={false}
                                            series={returnSeries}
                                            columns={["portfolio", "benchmark"]}
                                            style={style}
                                            interpolation="curveBasis"
                                            highlight={this.state.highlight}
                                            onHighlightChange={highlight =>
                                                this.setState({ highlight })
                                            }
                                            selection={this.state.selection}
                                            onSelectionChange={selection =>
                                                this.setState({ selection })
                                            }
                                        />
                                    </Charts>
                                </ChartRow>
                            </ChartContainer>
                        </Resizable>
                    </div>
                </div>
            </div>
        );
    }
}
export default Chart;



// WEBPACK FOOTER //
// ./src/components/charts/Chart.js